import ProductCard from "./ProductCard";

const ProductGrid = ({ products, selectedIds, onToggle }) => {
    return (
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-3">
            {products.map((product) => (
                <ProductCard
                    key={product.id}
                    product={product}
                    selected={selectedIds.includes(product.id)}
                    onToggle={onToggle}
                />
            ))}
        </div>
    );
};

export default ProductGrid;
